export default __webpack_public_path__ + "static/media/wordpress.c252e6aa.gif";